import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Legacycraftsmanshiphero from "./sections/Legacycraftsmanshiphero";
import OurStory from "./sections/OurStory";
import Ourstory from "./sections/Ourstory";
import Industrialcapabilities from "./sections/Industrialcapabilities";
import Companyvalues from "./sections/Companyvalues";
import Footer from "@/reusable_sections/Footer";
import Fabcocalltoaction from "./sections/Fabcocalltoaction";
export default function AboutPage() {
  return <div>
      <Header />
      <Legacycraftsmanshiphero />
      <Ourstory />
      <Industrialcapabilities />
      <Companyvalues />
      <OurStory />
      <Fabcocalltoaction />
      <Footer />
    </div>;
}